// extracted by mini-css-extract-plugin
export default {"netDiv":"SummaryStats_netDiv__19tsw","incomeText":"SummaryStats_incomeText__+YMgg","expensesText":"SummaryStats_expensesText__44I5h","netText":"SummaryStats_netText__GqO1i"};